/** A calm broadcaster chip: "● TNT Sports". Renders nothing when we don't
 *  honestly know where it's on — we never guess a channel. */
export const WatchChip = ({ tv }: { tv?: string | null }) =>
  tv ? (
    <span className="watch-chip">
      <span className="watch-chip-dot" aria-hidden="true" />
      {tv}
    </span>
  ) : null;
